import type { ThemePreference } from "@/hooks/useTheme";
import { THEME_OPTIONS } from "./settingsDrawerConstants";

export function SettingsDrawerAppearanceSection(props: {
  theme: ThemePreference;
  setTheme: (t: ThemePreference) => void;
}) {
  const { theme, setTheme } = props;
  return (
    <section className="space-y-3">
      <h3 className="text-xs font-semibold uppercase tracking-widest text-gray-500 dark:text-gray-400">Appearance</h3>
      <div>
        <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">Theme</p>
        <p className="text-[11px] text-gray-400 dark:text-gray-500 mb-2 leading-snug">
          Stored on this browser. It applies here and after you sign in; cloud profile sync can be added later.
        </p>
        <div className="flex flex-wrap gap-2">
          {THEME_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => setTheme(opt.value)}
              className={
                "min-w-[4.5rem] flex-1 flex flex-col items-center gap-1 py-2 px-1 rounded-xl border text-xs transition-colors " +
                (theme === opt.value
                  ? "border-indigo-400 bg-indigo-50 dark:bg-indigo-950 text-indigo-700 dark:text-indigo-300 font-medium"
                  : "border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700")
              }
            >
              <span className="text-base">{opt.icon}</span>
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
